import React, { useEffect, useState } from "react";
import Select from "react-select";
import {
  getByMonth,
  getTTodos,
  setCalls,
} from "../../store/reducers/dataReducer";
import {
  FlexRowBetween,
  GenericDiv,
  Input,
  Label,
  PopupForm,
} from "../common/Style";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import { parseIsoDate } from "../common/others/Functions";
import { editTal } from "../../store/reducers/todosReducer";

const TalsTodos = ({ uid, init }) => {
  const dispatch = useDispatch();
  const [tals, setTals] = useState(null);
  const [talName, setTalName] = useState(null);

  const handleChange = (selectedOption) => {
    // console.log("selectedOption: ", selectedOption.value);

    setTalName(selectedOption.value);
  };

  const handleSetTals = () => {
    dispatch(editTal({ uid, iid: talName })).then((res) => {
      if (!res.payload?.error) {
        toast.success("הפעולה בוצעה בהצלחה!!");
        init();
      } else toast.error(res.payload?.error);
    });
  };

  useEffect(() => {
    dispatch(getTTodos()).then((res) => {
      if (!res.payload?.error) {
        let arr = [];
        for (const [key, value] of Object.entries(res.payload))
          arr.push({ value: value.iid, label: key });
        setTals(arr);
      } else toast.error(res.payload?.error);
    });
  }, []);

  return (
    <PopupForm onClick={(e) => e.stopPropagation()}>
      <div
        style={{
          width: "90%",
          margin: "15px auto",
        }}
      >
        {tals && (
          <div style={{ marginBottom: "200px", paddingBottom: "200px" }}>
            <Label>בחירת טלפנית</Label>
            <Select options={tals} onChange={handleChange} />
          </div>
        )}
        <GenericDiv
          onClick={handleSetTals}
          style={{ margin: "10px auto", marginTop: "30px" }}
        >
          שליחה
        </GenericDiv>
      </div>
    </PopupForm>
  );
};

export default TalsTodos;
